/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadBatchGetRequest
 */
export interface UploadBatchGetRequest {
    /**
     * 
     */
    batchId: string;
}

/**
 * Check if a given object implements the UploadBatchGetRequest interface.
 */
export function instanceOfUploadBatchGetRequest(value: object): value is UploadBatchGetRequest {
    if ((!('batchId' in (value as Record<string, any>)) && !('batch_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['batchId'] === undefined && (value as Record<string, any>)['batch_id'] === undefined)) return false;
    return true;
}

export function UploadBatchGetRequestFromJSON(json: any): UploadBatchGetRequest {
    return UploadBatchGetRequestFromJSONTyped(json, false);
}

export function UploadBatchGetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchGetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'batchId': json['batch_id'],
    };
}

export function UploadBatchGetRequestToJSON(json: any): UploadBatchGetRequest {
    return UploadBatchGetRequestToJSONTyped(json, false);
}

export function UploadBatchGetRequestToJSONTyped(value?: UploadBatchGetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batch_id': value['batchId'],
    };
}

